import { MantineThemeOverride } from '@mantine/core';

export type ColorPickerTheme = NonNullable<MantineThemeOverride['components']>['ColorPicker'];

export const ColorPicker: ColorPickerTheme = {
  // todo: define
};
